/* ══════════════════════════════════════════════════════════════
   BRUTECH LORGAR PRODUCT PAGE
   Gallery with video support and spec decoder.
   NOTE: the theme already has a working sticky bar (#bp-sticky in
   main-product.liquid). We do not add a second one.
   Load AFTER brutech-partners.js
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ════════════════════════════════════════════════════════════
     1. GALLERY
  ════════════════════════════════════════════════════════════ */
  function initGallery(root) {
    if (root.dataset.blReady) return;
    root.dataset.blReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bl-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-bl-thumb]'));
    var stage  = root.querySelector('[data-bl-stage]');
    if (!slides.length || !stage) return;

    var current = 0;

    /* Stop any playing media inside a slide */
    function stopSlide(slide) {
      if (!slide) return;

      var vid = slide.querySelector('video');
      if (vid && !vid.paused) { try { vid.pause(); } catch (e) {} }

      /* External embeds: remove the iframe entirely so audio cannot
         continue and so YouTube stops tracking. Poster comes back. */
      var ext = slide.querySelector('[data-bl-video-external]');
      if (ext) {
        var frame = ext.querySelector('iframe');
        if (frame) frame.remove();
        var poster = ext.querySelector('[data-bl-poster]');
        if (poster) poster.style.display = '';
        ext.classList.remove('is-playing');
      }
    }

    function show(index, focusThumb) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      if (index === current && root.dataset.blInit) return;

      stopSlide(slides[current]);

      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      root.querySelectorAll('[data-bl-dot]').forEach(function (d, i) { d.classList.toggle('is-active', i === index); });

      current = index;
      root.dataset.blInit = '1';

      var counter = root.querySelector('[data-bl-current]');
      if (counter) counter.textContent = String(index + 1);

      /* Keep the active thumb in view without scrolling the page */
      if (focusThumb && thumbs[index] && thumbs[index].scrollIntoView) {
        thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(i); }
      });
    });

    var prev = root.querySelector('[data-bl-prev]');
    var next = root.querySelector('[data-bl-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1, true); });
    if (next) next.addEventListener('click', function () { show(current + 1, true); });

    /* Arrow keys when the gallery has focus */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); show(current - 1, true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1, true); }
    });

    /* Native video: big play button overlay */
    root.querySelectorAll('[data-bl-play]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var wrap = btn.closest('[data-bl-video]');
        var vid = wrap ? wrap.querySelector('video') : null;
        if (!vid) return;
        if (vid.paused) {
          vid.play().catch(function () {});
          wrap.classList.add('is-playing');
        } else {
          vid.pause();
          wrap.classList.remove('is-playing');
        }
      });
    });

    root.querySelectorAll('[data-bl-video] video').forEach(function (v) {
      var wrap = v.closest('[data-bl-video]');
      v.addEventListener('play',  function () { if (wrap) wrap.classList.add('is-playing'); });
      v.addEventListener('pause', function () { if (wrap) wrap.classList.remove('is-playing'); });
      v.addEventListener('ended', function () { if (wrap) wrap.classList.remove('is-playing'); });
    });

    /* External video: swap poster for iframe only on click.
       Nothing from YouTube or Vimeo loads until the user asks. */
    root.querySelectorAll('[data-bl-play-external]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var wrap = btn.closest('[data-bl-video-external]');
        if (!wrap || wrap.querySelector('iframe')) return;
        var tpl = wrap.querySelector('[data-bl-embed]');
        if (!tpl) return;
        wrap.appendChild(tpl.content.cloneNode(true));
        var poster = wrap.querySelector('[data-bl-poster]');
        if (poster) poster.style.display = 'none';
        wrap.classList.add('is-playing');
      });
    });

    /* Pause everything when the gallery scrolls out of view */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) stopSlide(slides[current]);
        });
      }, { threshold: 0.15 }).observe(root);
    }

    /* Swipe on mobile */
    var startX = 0, startY = 0, tracking = false;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      /* Horizontal intent only, so vertical page scroll still works */
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.6) {
        show(dx < 0 ? current + 1 : current - 1, true);
      }
    }, { passive: true });

    show(0);

    /* ── Public API ──
       Lets the variant picker drive the gallery without reaching into
       the DOM or faking clicks. Exposed on the gallery element itself,
       so multiple galleries on one page stay independent. */
    root.blGallery = {
      showIndex: function (i) { show(i, true); },

      showByMediaId: function (mediaId, opts) {
        if (mediaId === null || typeof mediaId === 'undefined') return false;
        opts = opts || {};

        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
            /* Already there, nothing to do */
            if (i === current) return true;

            /* Don't interrupt a video the shopper is actively watching
               unless the caller insists. */
            if (opts.respectPlayback !== false) {
              var active = slides[current];
              var vid = active ? active.querySelector('video') : null;
              if (vid && !vid.paused && !vid.ended) return false;
              var ext = active ? active.querySelector('[data-bl-video-external].is-playing') : null;
              if (ext) return false;
            }

            show(i, true);
            return true;
          }
        }
        return false;
      },

      getCurrentIndex: function () { return current; }
    };
  }

  /* ════════════════════════════════════════════════════════════
     2. SPEC DECODER
     Turns metafield-driven spec rows into stat bars.
     Reads data-bl-spec="label|value|percent"
  ════════════════════════════════════════════════════════════ */
  function initSpecs() {
    var rows = document.querySelectorAll('[data-bl-spec]');
    if (!rows.length) return;

    if (!('IntersectionObserver' in window)) {
      rows.forEach(function (r) { r.classList.add('is-filled'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var pct = parseFloat(el.getAttribute('data-bl-percent')) || 0;
        var fill = el.querySelector('.bl-spec-fill');
        if (fill) fill.style.width = Math.min(100, Math.max(0, pct)) + '%';
        el.classList.add('is-filled');
        io.unobserve(el);
      });
    }, { threshold: 0.4 });

    rows.forEach(function (r) { io.observe(r); });
  }

  /* ════════════════════════════════════════════════════════════
     3. RUN
  ════════════════════════════════════════════════════════════ */
  function init() {
    try {
      document.querySelectorAll('[data-bl-gallery]').forEach(initGallery);
      initSpecs();
    } catch (e) {
      console.warn('[Brutech] LORGAR product:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* Shopify section re-render (variant change) */
  document.addEventListener('shopify:section:load', init);
})();
